import React, { createContext, useContext, useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Dark mode is disabled - always use light theme
  const [theme] = useState<Theme>('light');

  // Apply light theme class to html element
  useEffect(() => {
    const root = window.document.documentElement;

    // Remove both classes first
    root.classList.remove('light', 'dark');

    // Always add light class
    root.classList.add('light');
  }, []);

  // No-op toggle function (dark mode is disabled)
  const toggleTheme = () => {
    // Dark mode is disabled
  };

  // No-op setTheme function (dark mode is disabled)
  const setThemeNoOp = () => {
    // Dark mode is disabled
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme: setThemeNoOp }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  
  return context;
};

export default ThemeContext; 